const localState = {
    show: false,
    answered: false,
    session: null,
    incomingCallAudio: null,
    callOptions: {
        mediaConstraints: { audio: true, video: false },
    },

    clientModal: false,
    orderModal: false,
    isCallToClient: false,
    callee: null,
    showMaster: false,
    showClient: false,
    showSip: false,
    phoneInstance: null,
    master: null,
    options: {
        sipgateWSS: 'wss://sip.sipgate.de',
        sipgateUrl: '3052041e6@sipgate.de',
        sipgatePassword: 'kF7JAmQZHsoU',
    },
    callerName: null,
}

const mutations = {
    setState: (state, { key, value }) => {
        state[key] = value
    },
}

const getters = {
    show: (state) => state.show,
    answered: (state) => state.answered,
    session: (state) => state.session,
    incomingCallAudio: (state) => state.incomingCallAudio,
    callOptions: (state) => state.callOptions,

    clientModal: (state) => state.clientModal,
    orderModal: (state) => state.orderModal,
    isCallToClient: (state) => state.isCallToClient,
    callee: (state) => state.callee,
    showMaster: (state) => state.showMaster,
    showClient: (state) => state.showClient,
    showSip: (state) => state.showSip,
    phoneInstance: (state) => state.phoneInstance,
    master: (state) => state.master,
    options: (state) => state.options,
    callerName: (state) => state.callerName,
}

const actions = {}

export default {
    namespaced: true,
    state: localState,
    mutations,
    getters,
    actions,
}
